"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PRODUCT_ERROR = 'Error getting information about selected product';
var EVENT_ERROR = 'Error getting information about selected workspace';
var OrgAssignEntitlement = /*#__PURE__*/function () {
  OrgAssignEntitlement.$inject = ["$rootScope", "$scope", "$q", "$location", "modalService", "eventService", "entitlementsService"];
  /* @ngInject */
  function OrgAssignEntitlement($rootScope, $scope, $q, $location, modalService, eventService, entitlementsService) {
    _classCallCheck(this, OrgAssignEntitlement);
    this.$q = $q;
    this.loading = true;
    this.$scope = $scope;
    this.$location = $location;
    this.$rootScope = $rootScope;
    this.modalService = modalService;
    this.eventService = eventService;
    this.entitlementsService = entitlementsService;
  }

  /**
   * Initializes data
   *
   */
  return _createClass(OrgAssignEntitlement, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.loading = true;
      var queryParams = this.$location.search();
      this.$q.all([
      // get entitlements available
      this.entitlementsService.getAvailableProducts(this.organisation._id).then(function (products) {
        return _this.product = products.find(function (product) {
          return product.name === queryParams.product;
        });
      }).then(function () {
        return _this.entitlementsService.getOrganizationProductPools(_this.organisation._id, _this.product.productCodes);
      }).then(function (productEntitlements) {
        _this.productsEntitlements = productEntitlements;
        _this.selectedEntitlement = productEntitlements[0];
      }).catch(function /* error */ () {
        return _this.eventUsageError = PRODUCT_ERROR;
      }),
      // retrieve current event usage
      this.entitlementsService.getOrganizationEventEntitlements(this.organisation._id, this.eventId || queryParams.eid).then(function (eventEntitlements) {
        var eventProducts = eventEntitlements.products;
        var product = eventProducts.find(function (product) {
          return product.name === queryParams.product;
        });
        _this.eventUsage = product ? product.usage : {
          used: 0,
          available: 0
        };
      }).catch(function /* error */ () {
        return _this.eventUsageError = PRODUCT_ERROR;
      }),
      // retrieve event details
      this.eventService.getEvent(this.eventId || queryParams.eid).then(function (event) {
        return _this.event = event;
      }).catch(function /* error */ () {
        return _this.eventError = EVENT_ERROR;
      })]).finally(function () {
        return _this.loading = false;
      });
    }

    /**
     * Makes a transaction assigning the currently selected product with quantity to the current workspace
     *
     */
  }, {
    key: "makeTransaction",
    value: function makeTransaction() {
      var _this2 = this;
      var isMultiple = this.selectedEntitlement.entitlement.product.multiple;
      if (isMultiple && (!this.productQuantity || this.productQuantity > this.selectedEntitlement.available)) {
        return;
      }
      if (!isMultiple && this.eventUsage.available) {
        return;
      }
      this.modalService.openModal({
        templateUrl: '/src/angular/components/orgs/view-org/org-entitlements-manager/org-assign-entitlement/org-confirm-assign-entitlement.html',
        scope: {
          productName: this.product.name,
          eventName: this.event.eventname,
          productQuantity: this.productQuantity
        }
      }).then(function () {
        return _this2.entitlementsService.createEntitlementTransaction({
          parentEntitlementId: _this2.selectedEntitlement.id,
          quantity: _this2.productQuantity || 1,
          organisationID: _this2.organisation._id,
          eventId: _this2.event.id
        });
      }).then(function () {
        _this2.$scope.$emit('CHANGE_TAB', {
          tab: 'per-event-entitlements',
          params: {
            eid: _this2.event.id
          }
        });
        return _this2.$rootScope.setFlashMessage('Transaction executed.');
      }).catch(function (err) {
        if (err === 'cancelConfirmModal') {
          return;
        }
        return _this2.$rootScope.setFlashMessage('An error occured while making the transaction, please try again later.', 'danger');
      });
    }

    /**
     * Class helper for usage
     * @param {Number} ratio
     * @return {String}
     */
  }, {
    key: "getMultipleUsageClass",
    value: function getMultipleUsageClass(ratio) {
      if (ratio * 100 <= 100) {
        return 'text-success';
      } else if (ratio * 100 < 110) {
        return 'text-warning';
      } else {
        return 'text-error';
      }
    }
  }]);
}();
module.exports = angular.module('backstage.components.orgs.view-org.entitlements-manager.org-assign-entitlement', ['backstage.services']).component('bsOrgAssignEntitlement', {
  templateUrl: '/src/angular/components/orgs/view-org/org-entitlements-manager/org-assign-entitlement/org-assign-entitlement.html',
  bindings: {
    organisation: '<',
    eventId: '<'
  },
  controllerAs: 'vm',
  controller: OrgAssignEntitlement
}).name;